import { cx } from 'class-variance-authority';

import useHeaderOpacity from '@/app/[locale]/product/_hooks/useHeaderOpacity';

import DiscountMessage from '../DiscountMessage';
import Footer from './Footer';
import LayoutImage from './LayoutImage';
import MainContent from './MainContent';
import MobileHeader from './MobileHeader';
import Tabs from './Tabs';
import type { LayoutProps } from './types';
import VariantLabel from './VariantLabel';

const MobileLayout = ({
  children,
  currentStep,
  hasEyebrow,
  inverseHeader,
  isAccessory,
  isOuraRing4Wizard,
  itemCountForIcon,
}: LayoutProps) => {
  const { container, opacity } = useHeaderOpacity();
  const gradientOpacity = opacity < 1 ? opacity / 4 : 0.25;

  return (
    <div
      className="h-dvh overflow-y-scroll bg-sandstone-100 lg:hidden"
      data-cy="wizard-mobile-layout"
      ref={container}
    >
      <DiscountMessage />
      <MobileHeader
        hasEyebrow={hasEyebrow}
        inverseHeader={inverseHeader}
        isAccessory={isAccessory}
        isOuraRing4Wizard={isOuraRing4Wizard}
        itemCountForIcon={itemCountForIcon}
        opacity={opacity}
      />

      <MainContent>
        <div className="relative top-0 z-10 bg-gray-150">
          <VariantLabel inverseHeader={inverseHeader} />
          <div className="relative aspect-[2/1.69] max-h-[60vh] w-screen max-w-(--breakpoint-lg)">
            <LayoutImage
              currentStep={currentStep}
              isAccessory={isAccessory}
              isOuraRing4Wizard={isOuraRing4Wizard}
            />
            <div
              className={cx(
                'pointer-events-none absolute inset-0 bg-linear-to-t from-black to-sandstone-500 transition-all',
              )}
              style={{ opacity: gradientOpacity }}
            />
          </div>
        </div>

        <div className="relative z-10 -mt-2 rounded-t-xl bg-sandstone-100 pt-2">
          <div
            className="sticky z-30 border-b border-gray-300 bg-sandstone-100"
            data-cy="mobile-layout-tabs"
            style={{ top: hasEyebrow ? '6rem' : '3rem' }}
          >
            <Tabs />
          </div>
          <div className="flex w-full flex-col">
            <div className="top-0 mb-[100px] grow p-4">{children}</div>
            <Footer />
          </div>
        </div>
      </MainContent>
    </div>
  );
};

export default MobileLayout;
